import { render, staticRenderFns } from "./LayoutPage.vue?vue&type=template&id=f6d62e06"
import script from "./LayoutPage.vue?vue&type=script&lang=js"
export * from "./LayoutPage.vue?vue&type=script&lang=js"
import style0 from "./LayoutPage.vue?vue&type=style&index=0&id=f6d62e06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports